<template>
  <div
    class="d-post-poll"
    :disabled="isDisabled"
  >
    <!-- Poll type picker -->
    <div v-if="!pollType">
      <div class="grid-flex grid-no-response">
        <div class="grid-item">
          <h4>Configure your poll</h4>
        </div>
        <div class="grid-item-shrink">
          <button
            class="button-grey button-icon button-sm button-close"
            title="Cancel"
            @click="clearPostType()"
          />
        </div>
      </div>

      <DPostPollTypes
        class="space-top-1em"
        :poll-types="pollTypes"
        @poll-type-selected="pollTypeSelected"
      />
    </div>
    <!-- END Poll type picker -->

    <div v-if="pollType === pollTypes.compareImages">
      <div class="grid-flex grid-no-response">
        <div class="grid-item">
          <h4>Compare two options</h4>
        </div>
        <div
          v-if="!editingPollType"
          class="grid-item-shrink"
        >
          <button
            class="button-grey button-icon button-sm button-close"
            title="Cancel"
            @click="clearPollType()"
          />
        </div>
      </div>

      <DPostPollCompareImages :post-info="postInfo" />
    </div>

    <div v-if="pollType === pollTypes.multipleChoice">
      <div class="grid-flex grid-no-response">
        <div class="grid-item">
          <h4>Multiple choice</h4>
        </div>
        <div
          v-if="!editingPollType"
          class="grid-item-shrink"
        >
          <button
            class="button-grey button-icon button-sm button-close"
            title="Cancel"
            @click="clearPollType()"
          />
        </div>
      </div>

      <DPostPollMultipleChoice :post-info="postInfo" />
    </div>
  </div>
</template>

<script>
import DPostPollCompareImages from './d-post-poll-compare-images/d-post-poll-compare-images.vue';
import DPostPollMultipleChoice from './d-post-poll-multiple-choice/d-post-poll-multiple-choice.vue';
import DPostPollTypes from './d-post-poll-types/d-post-poll-types.vue';
import postTypeMixin from '../post-type-mixin';

export const POLL_TYPES = Object.freeze({
  compareImages: {
    key: 'compareImages',
    label: 'Compare two options',
  },
  multipleChoice: {
    key: 'multipleChoice',
    label: 'Multiple choice',
  },
});

export default {
  components: {
    DPostPollCompareImages,
    DPostPollMultipleChoice,
    DPostPollTypes,
  },
  mixins: [
    postTypeMixin,
  ],
  props: {
    editingPollType: {
      type: Object,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    postInfo: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    pollType: null,
    pollTypes: POLL_TYPES,
  }),
  mounted() {
    this.setEditingContent();
  },
  methods: {
    blinkPoll() {
      this.$el.classList.remove('blink');
      setTimeout(() => {
        this.$el.classList.add('blink');
      }, 100);
    },

    clearPollType() {
      this.$set(this, 'pollType', null);
    },

    pollTypeSelected(pollType) {
      this.$set(this, 'pollType', pollType);
    },

    setEditingContent() {
      if (!this.editingPollType) {
        return;
      }

      this.pollTypeSelected(this.editingPollType);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-post-poll {
  &[disabled] {
    opacity: $disabled-opacity;
    pointer-events: none;
  }

  &.blink,
  &.blink h4 {
    animation-duration: $transition-time-blink;
    animation-fill-mode: forwards;
  }

  &.blink {
    animation-name: blink-border-red;

    h4 {
      animation-name: blink-color-red;
    }
  }
}
</style>
